import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const TextLink = styled.a`
    color: ${Colors.Blue.V200};
    text-decoration: none;

    &:hover,
    &:focus,
    &:active {
        color: ${Colors.Blue.V200};
        text-decoration: none;
    }
`;

export const UnderlinedTextLink = styled(TextLink)`
    text-decoration: underline;

    &:hover,
    &:focus,
    &:active {
        text-decoration: underline;
    }
`;
